module.exports = __webpack_public_path__ + "static/media/darkGradient.cc96e7b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/darkGradient.svg
// module id = 783
// module chunks = 0